"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastCalledInterpreter = void 0;
const filter_1 = require("@dqm/filter");
class LastCalledInterpreter {
    constructor() {
        this.filters = [];
        this.topBarValues = [];
        const compiler = new filter_1.FilterCompiler(new filter_1.ObjectFilterGenerator());
        for (const filter of this.getQueueFilters()) {
            this.filters.push(compiler.compile(filter));
        }
    }
    updateLastCalled(qn) {
        for (const index in this.filters) {
            if (this.filters[index](qn)) {
                this.topBarValues[index] = qn;
            }
        }
        return this.topBarValues;
    }
    getQueueFilters() {
        return [
            {
                operator: "or",
                operands: [
                    {
                        operator: "in",
                        field: "tags",
                        value: "queue:yksityisasiakas",
                    },
                    {
                        operator: "in",
                        field: "tags",
                        value: "queue:yritysasiakas",
                    },
                ],
            },
            {
                operator: "in",
                field: "tags",
                value: "queue:nettitilauksen-nouto",
            },
        ];
    }
}
exports.LastCalledInterpreter = LastCalledInterpreter;
//# sourceMappingURL=LastCalledInterpreter.js.map